import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PublicComponent } from './public.component';
import { VersionComponent } from './version/version.component';
import { ConnectIntegrationsComponent } from './connect-integrations/connect-integrations.component';
import { RedirectComponent } from './oauth-redirect/redirect.component';
import { ConnectTradeDeskAgencyComponent } from './connect-trade-desk-agency/connect-trade-desk-agency.component';
import { InstallationComponent } from '../portal/tags/installation/installation.component';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'version',
        component: VersionComponent
      },
      {
        path: 'oauth-redirect/:platform',
        component: RedirectComponent
      },
      {
        path: 'connect-integrations/:token',
        component: ConnectIntegrationsComponent
      },
      {
        path: 'ttd-agency-connect',
        component: ConnectTradeDeskAgencyComponent
      },
      {
        path: 'tag-install/:token',
        component: InstallationComponent
      }
    ])
  ],
  exports: [RouterModule]
})
export class PublicRoutingModule {}
